import styled from 'styled-components';
import { Typography } from '~/ui/components';
import { themeColor, themeToggleColor } from '~/common/utils/theme';

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const ListBody = styled(Typography).attrs(({ theme }) => ({
  type: 'caption',
  element: 'p',
  weight: 400,
  color: themeToggleColor(theme, 'element.primary', { dark: 'element.invert' }),
}))`
  margin: 0;
`;

export const SectionDivider = styled.div`
  height: 1px;
  background-color: ${themeColor('neutral.secondaryAlt')};
  margin: 4px 0;
`;

export const SectionTitle = styled(Typography).attrs(({ theme }) => ({
  type: 'footnote',
  element: 'p',
  weight: 600,
  color: themeToggleColor(theme, 'element.secondary', { dark: 'element.secondary' }),
}))`
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 4px 0;
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 0;
  border-bottom: 1px solid ${themeColor('neutral.secondaryAlt')};
  &:last-child {
    border-bottom: none;
  }
`;

export const RowTitle = styled(Typography).attrs(({ theme }) => ({
  type: 'caption',
  element: 'p',
  weight: 600,
  color: themeToggleColor(theme, 'element.primary', { dark: 'element.invert' }),
}))`
  margin: 0;
`;

export const RowDescription = styled(Typography).attrs(({ theme }) => ({
  type: 'footnote',
  element: 'p',
  weight: 400,
  color: themeToggleColor(theme, 'element.secondary', { dark: 'element.secondary' }),
}))`
  margin: 0;
`;
